import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 新建品牌 ")
const _hoisted_5 = { style: {"color":"#317efd"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 新建品牌 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_v_nodes = _resolveComponent("v-nodes")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_form_btn = _resolveComponent("form-btn")!
  const _component_a_select = _resolveComponent("a-select")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: _ctx.value,
    "allow-clear": "",
    "show-search": "",
    multiple: false,
    placeholder: _ctx.placeholder,
    "option-filter-prop": "title",
    onChange: _ctx.onChange,
    onClear: _ctx.onClear,
    onSearch: _ctx.handleSearch
  }, {
    dropdownRender: _withCtx(({ menuNode: menu }) => [
      _createVNode(_component_v_nodes, { vnodes: menu }, null, 8, ["vnodes"]),
      _createVNode(_component_a_divider, { style: {"margin":"4px 0"} }),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        style: {"padding":"4px 8px","cursor":"pointer","color":"rgba(0, 0, 0, 0.85)"},
        onMousedown: _cache[0] || (_cache[0] = (e) => e.preventDefault()),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args)))
      }, [
        _createVNode(_component_form_btn, {
          "material-category-id": _ctx.categoryId,
          "default-brand": _ctx.addText,
          onRefresh: _ctx.finishCreateBrand
        }, {
          addBrand: _withCtx(({ showCreateModal }) => [
            _createElementVNode("div", { onClick: showCreateModal }, [
              _createVNode(_component_plus_outlined),
              (_ctx.addText)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_4,
                    _createElementVNode("span", _hoisted_5, "\"" + _toDisplayString(_ctx.addText) + "\"", 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_6
                  ], 64))
            ], 8, _hoisted_3)
          ]),
          _: 1
        }, 8, ["material-category-id", "default-brand", "onRefresh"])
      ], 32)), [
        [_directive_perm, 'material-brand-create']
      ])
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result || [], (item) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          value: item.id,
          title: item.name
        }, {
          default: _withCtx(() => [
            (_ctx.keyword)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  innerHTML: _ctx.searchFun(_ctx.keyword, item.name)
                }, null, 8, _hoisted_1))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(item.name), 1))
          ]),
          _: 2
        }, 1032, ["value", "title"]))
      }), 256))
    ]),
    _: 1
  }, 8, ["value", "placeholder", "onChange", "onClear", "onSearch"]))
}